let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5dNkA")).then(() => parcelRequire('azuEZ'));